import React from "react";
import PropTypes from "prop-types";

import { ALL_STATIONS_TAB_ID } from "../../constants/mapTabs";
import ChargingMap from "../LocationMap/ChargingMap";

import "./TabbedMaps.scss";
import { FormattedMessage } from "react-intl";

const TabbedMaps = ({
  chargingStationsFilterFn,
  electricVehicles,
  oems,
  activeTabId,
  toggle,
  canIgnoreLowPowerStations = true,
  userLocation,
  dealerLocations,
  zipcode,
}) => (
  <div className="TabbedMaps">
    <div className="container">
      {electricVehicles ? null : (
        <div className="titleContainer title-box">
          {activeTabId === "tabbed-maps-all-stations-tab" ? (
            <>
              <h2 className="title">Charging Stations</h2>
              <p className="subtitle">
                <FormattedMessage
                  id="ev.chargingStations.body"
                  defaultMessage="Charging stations Body"
                  description="Charging stations Body"
                  values={{
                    lineBreak: <br />,
                  }}
                />
              </p>
            </>
          ) : (
            <>
              <h2 className="title">Plan Your Route</h2>
              <p className="subtitle">
                <FormattedMessage
                  id="ev.planningRoute.body"
                  defaultMessage="Plan Route Body"
                  description="Plan Route Body"
                  values={{
                    lineBreak: <br />,
                  }}
                />
              </p>
            </>
          )}
        </div>
      )}
      <div className="tabbed-maps-panel">
        <ChargingMap
          userLocation={userLocation}
          isVisible={activeTabId === ALL_STATIONS_TAB_ID}
        />
      </div>
    </div>
  </div>
);

TabbedMaps.propTypes = {
  chargingStationsFilterFn: PropTypes.func,
  electricVehicles: PropTypes.array,
  oems: PropTypes.array,
  activeTabId: PropTypes.string,
  toggle: PropTypes.func,
  canIgnoreLowPowerStations: PropTypes.bool,
};

export default TabbedMaps;
